import { render } from "./FeaturedProperties.vue?vue&type=template&id=6b839a7d&scoped=true"
import script from "./FeaturedProperties.vue?vue&type=script&lang=js"
export * from "./FeaturedProperties.vue?vue&type=script&lang=js"

import "./FeaturedProperties.vue?vue&type=style&index=0&id=6b839a7d&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b839a7d"]])

export default __exports__